import React from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../userContext';
import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardHeader, Container, Typography } from '@mui/material';
import Styles from '../common/styles/styles';

export default function TermsPopup() {
  const { userName, updateUserName, updateTermsAccepted, updateEulaAccepted, updateAuthenticated, updateUserId } = useUser();

  const navigate = useNavigate();

  const handleDecline = () => {
    updateUserId(null); 
    updateUserName(null); 
    updateTermsAccepted(false); 
    updateEulaAccepted(false);
    updateAuthenticated(false); 
    navigate('/');
  };

  const handleAccept = async () => {
    
    try {
      const response = await fetch((`${process.env.REACT_APP_API}/users/validateEula/${userName}`), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const result = await response.json();
      if (result.message) {
        updateTermsAccepted(true); 
        updateEulaAccepted(true);
        updateAuthenticated(true);
        navigate('/alerts'); 
      } else {
        updateTermsAccepted(true); 
        navigate('/eula'); 
      }
    } catch (error) {
      toast.error('Network error.  Please try again: ', error);
    }
  };

  return (
    <Container component="main" maxWidth="xs" sx={{ mt: 15 }}>
        <Box
          sx={{
            alignItems: 'center',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            height: '75vh', 
            maxHeight: '75vh', 
            overflowY: 'auto', 
            backgroundColor: '#fff',
            borderRadius: '8px',
            zIndex: 1000,
          }}
        >
            <Box
                sx={{
                  // Removing Fixed Adds The Scroll Bar That George Is Looking For
                  position: 'fixed',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000,
                }}
            >
                <Card sx={{
                  width: '90%',
                  maxWidth: '600px',
                  padding: '20px',
                  fontFamily: 'monospace',
                }}>
                      <CardHeader title = 'ATTENTION' sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '20px' }} >
                      </CardHeader>
                      <CardContent>
                          <Typography  component="div" sx={{ fontSize: '18px', color: 'rgb(252, 1, 1)', textAlign: 'center', }} >
                              THIS IS A RESTRICTED COMPUTER SYSTEM
                          </Typography>
                          <Typography  sx={{ fontFamily: 'monospace', fontSize: '14px', marginBottom: '20px', marginTop: '20px', maxHeight: '60vh', overflowX: 'auto' }} >
                              This computer system, and all related equipment, networks, and network devices are provided for authorised use only. 
                              All systems controlled by this organisation will be monitored for all lawful purposes. Monitoring includes the totality of the operating system and connected networks. 
                              No events on this system are excluded from record and there are no exclusions from this policy.
                          </Typography>

                          <Typography sx={{ fontFamily: 'monospace', fontSize: '14px', marginBottom: '20px', marginTop: '20px', maxHeight: '60vh', overflowX: 'auto' }} >
                              Use of this system constitutes consent to full monitoring of your activities for use by the authorised monitoring organisation. 
                              Unauthorised use of this system, including uninvited connections, may subject you to criminal prosecution.
                          </Typography>

                          <Typography  sx={{ fontFamily: 'monospace', fontSize: '14px', marginBottom: '20px', marginTop: '20px', maxHeight: '60vh', overflowX: 'auto' }} >
                              The data collected from this system may be used for any purpose by the collecting organisation. 
                              If you do not agree to this monitoring, discontinue use of the system IMMEDIATELY.
                          </Typography>
                          <Typography  component="div" sx={{ fontSize: '18px', color: 'rgb(252, 1, 1)', textAlign: 'center', }} >
                              THIS IS A RESTRICTED COMPUTER SYSTEM
                          </Typography>

                          <CardActionArea sx={{ marginTop: '20px', '.MuiCardActionArea-focusHighlight': { background: '#FFFFFF' } }}>
                              <CardActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <Button onClick={handleDecline} sx={{ ...Styles.buttonStyle, color: '#FFF', ml:4, '&:hover': {backgroundColor: '#7984ba'} }} >Decline</Button>
                                  <Button onClick={handleAccept} sx={{ ...Styles.buttonStyle, color: '#FFF', ml:4, '&:hover': {backgroundColor: '#7984ba'} }}>Accept</Button>
                              </CardActions>
                          </CardActionArea>
                      </CardContent>
                </Card>
            </Box>
        </Box>
    </Container>
  );
}
